import { render, staticRenderFns } from "./PurchaseRequestItemQuantityInput.vue?vue&type=template&id=5f7de4ba&"
import script from "./PurchaseRequestItemQuantityInput.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestItemQuantityInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports